module.exports = __webpack_public_path__ + "static/media/softwareDevelopment.cea2c295.svg";